(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const fadeStep1Elements = document.querySelectorAll('.fade-step-1');
    const fadeStep2Elements = document.querySelectorAll('.fade-step-2');
    setTimeout(() => {
        fadeStep1Elements.forEach(element => {
            element.classList.add('show');
        });
    }, 500);
    setTimeout(() => {
        fadeStep2Elements.forEach(element => {
            element.classList.add('show');
        });
    }, 1100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-intro"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const rightText = document.getElementById('right-text');
    const leftText = document.getElementById('left-text');
    const rightTextContainer = document.getElementById('right-text-container');
    const leftTextContainer = document.getElementById('left-text-container');

    if (rightText && rightText.textContent && rightText.textContent.trim() !== '') {
      rightTextContainer.innerHTML = splitTextBySpace(rightText.textContent);
      rightTextContainer.classList.remove('hidden');
    }

    if (leftText && leftText.textContent && leftText.textContent.trim() !== '') {
      leftTextContainer.innerHTML = splitTextBySpace(leftText.textContent);
      leftTextContainer.classList.remove('hidden');
    }
  });

  function splitTextBySpace(text) {
    if (!text || text.trim() === '') return '';
    return text.split(' ').map(word => `<p class="fs-ko-c1 text-vertical">${word}</p>`).join('');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const fadeStep1Elements = document.querySelectorAll('.fade-step-1');
    const fadeStep2Elements = document.querySelectorAll('.fade-step-2');
    setTimeout(() => {
        fadeStep1Elements.forEach(element => {
            element.classList.add('show');
        });
    }, 500);
    setTimeout(() => {
        fadeStep2Elements.forEach(element => {
            element.classList.add('show');
        });
    }, 1100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tea-method"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const methodVideo = document.getElementById('methodVideo');
    if (methodVideo) {
        methodVideo.play();
    }
});

  } catch(e) { console.error(e); }
})();
})();
